import securityIcon from "@/Assets/SecurityPage.jpg";

export default function SecureInfrastructureSection() {
  const points = [
    "Virtual private cloud (VPC) architecture",
    "Network-level firewalls and intrusion protection",
    "Continuous vulnerability scanning",
    "Auto-scaling with secure load balancing",
    "Disaster recovery and backup systems",
  ];

  return (
    <section className="w-full pt-20 pb-5 px-4 md:px-8">
      <div className="container-width mx-auto max-w-6xl">
        {/* Top Content */}
        <div className="text-center max-w-3xl mx-auto mb-14">
          <h2 className="text-3xl md:text-5xl font-semibold text-neutral-950 mb-4 leading-tight">
            Secure & Scalable Infrastructure
          </h2>

          <p className="text-neutral-600 text-base md:text-lg">
            Our platform runs on highly secure cloud environments with network
            isolation, continuous monitoring, and automated scaling.
          </p>
        </div>

        {/* Bottom Layout */}
        <div className="grid md:grid-cols-2 gap-10 items-center">
          {/* Left Accent */}
          <div className="hidden md:flex items-center justify-center">
            <div className="w-64 h-64 rounded-full overflow-hidden">
              <img
                src={securityIcon}
                alt="Secure Infrastructure"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right Points */}
          <div className="space-y-5">
            {points.map((point, index) => (
              <div
                key={index}
                className="flex items-start gap-4 group transition-all"
              >
                {/* Indicator */}
                <div className="mt-2 w-2.5 h-2.5 rounded-full bg-primary shrink-0 group-hover:scale-125 transition-transform"></div>

                {/* Text */}
                <p className="text-neutral-700 text-sm md:text-base leading-relaxed">
                  {point}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
